import React from "react";
import { useNavigate } from "react-router-dom";
import "../css/redbullLanding.css";

export default function TermsOfUse() {
  const navigate = useNavigate();

  return (
    <div style={{ background: "#0e0e0e", color: "#e0e0e0", minHeight: "100vh", fontFamily: "'Bull Text', Arial, sans-serif" }}>
      <header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "18px 40px", borderBottom: "1px solid #222" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 14, cursor: "pointer" }} onClick={() => navigate("/")}>
          <img
            src="https://upload.wikimedia.org/wikipedia/en/thumb/8/8e/Red_Bull_Jobs_logo.svg/800px-Red_Bull_Jobs_logo.svg.png"
            alt="Red Bull"
            style={{ height: 32, filter: "brightness(0) invert(1)" }}
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <span style={{ fontFamily: "'Bull', sans-serif", fontWeight: 700, fontSize: 20, color: "#fff" }}>Red Bull Jobs</span>
        </div>
        <button
          onClick={() => navigate("/")}
          style={{ background: "none", border: "1px solid #555", color: "#fff", padding: "8px 20px", borderRadius: 4, cursor: "pointer", fontSize: 14, fontFamily: "'Bull Text', sans-serif" }}
        >
          Back to Home
        </button>
      </header>

      <main style={{ maxWidth: 820, margin: "0 auto", padding: "48px 24px 80px" }}>
        <h1 style={{ fontFamily: "'Bull', sans-serif", fontWeight: 800, fontSize: 36, color: "#fff", marginBottom: 8 }}>Terms of Use</h1>
        <p style={{ color: "#888", fontSize: 14, marginBottom: 36 }}>Last updated: February 20, 2026</p>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>1. Acceptance of Terms</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            By accessing and using the Red Bull Careers website ("Site"), you accept and agree to be bound by these Terms of Use. If you do not agree to these terms, please do not use the Site. We reserve the right to modify these terms at any time, and your continued use of the Site constitutes acceptance of any changes.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>2. Use of the Site</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginBottom: 12 }}>You agree to use this Site only for lawful purposes and in accordance with these Terms. You agree not to:</p>
          <ul style={{ color: "#bbb", lineHeight: 1.8, paddingLeft: 24 }}>
            <li>Use the Site in any way that violates applicable laws or regulations</li>
            <li>Attempt to gain unauthorized access to any part of the Site or its systems</li>
            <li>Submit false, misleading, or fraudulent information in any application</li>
            <li>Use automated systems or software to extract data from the Site</li>
            <li>Interfere with or disrupt the integrity or performance of the Site</li>
          </ul>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>3. Account and Authentication</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            Certain features of the Site may require you to create an account or sign in using third-party authentication services (such as Google). You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. You agree to notify us immediately of any unauthorized use of your account.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>4. Intellectual Property</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            All content on this Site, including but not limited to text, graphics, logos, images, trademarks, and software, is the property of Red Bull GmbH or its licensors and is protected by international intellectual property laws. You may not reproduce, distribute, modify, or create derivative works from any content without prior written consent.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>5. Job Applications</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            Submitting an application through this Site does not guarantee employment or an interview. Red Bull reserves the right to accept or reject any application at its sole discretion. All information submitted must be accurate and truthful. Providing false information may result in disqualification from consideration and termination of any offer of employment.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>6. Third-Party Services</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            The Site may contain links to or integrations with third-party websites and services, including Google Sign-In and Calendly scheduling. These third-party services are governed by their own terms and privacy policies. Red Bull is not responsible for the content, accuracy, or practices of any third-party services.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>7. Disclaimer of Warranties</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            The Site is provided on an "as is" and "as available" basis without warranties of any kind, whether express or implied. Red Bull does not warrant that the Site will be uninterrupted, error-free, or free of viruses or other harmful components. Your use of the Site is at your sole risk.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>8. Limitation of Liability</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            To the fullest extent permitted by law, Red Bull shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from or related to your use of the Site. In no event shall our total liability exceed one hundred euros (€100).
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>9. Governing Law</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            These Terms of Use shall be governed by and construed in accordance with the laws of Austria, without regard to its conflict of law provisions. Any disputes arising under these terms shall be subject to the exclusive jurisdiction of the courts in Salzburg, Austria.
          </p>
        </section>

        <section style={{ marginBottom: 32 }}>
          <h2 style={{ fontSize: 20, fontWeight: 700, color: "#fff", marginBottom: 12 }}>10. Contact Us</h2>
          <p style={{ lineHeight: 1.7, color: "#bbb" }}>
            If you have any questions about these Terms of Use, please contact us at:
          </p>
          <p style={{ lineHeight: 1.7, color: "#bbb", marginTop: 8 }}>
            <strong style={{ color: "#e0e0e0" }}>Red Bull GmbH</strong><br />
            Am Brunnen 1<br />
            5330 Fuschl am See, Austria<br />
            Email: legal@redbull.com
          </p>
        </section>
      </main>

      <footer style={{ borderTop: "1px solid #222", padding: "24px 40px", textAlign: "center" }}>
        <span style={{ color: "#666", fontSize: 13 }}>© 2026 Red Bull GmbH. All rights reserved.</span>
      </footer>
    </div>
  );
}
